import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="spinner-border text-primary" role="status">
      <span className="sr-only"></span>
    </div>
  );
};

export default LoadingSpinner;
